import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import oktaConfig from './common/config/oktaConfig';

import AppRoutes from './AppRoutes';
import { AuthProvider } from './common/contexts/AuthContext';
import TimeoutCheck from './views/Layout/TimeoutCheck';
import { NotificationProvider } from './common/contexts/NotificationContext';

import TopBar from './views/Layout/TopBar';
import Footer from './views/Layout/Footer';

const oktaAuth = new OktaAuth(oktaConfig);

const AppRoot = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <AuthProvider>
        <NotificationProvider>
          <TimeoutCheck />
          <TopBar />
          <main>
            <div className="flex flex-1 flex-col items-stretch h-full">
              <AppRoutes />
            </div>
          </main>
          <Footer />
        </NotificationProvider>
      </AuthProvider>
    </Security>
  );
};

export default AppRoot;
